<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="评论内容">
                  <el-input style='width: 186px;' v-model="queryForm.comment"></el-input>
              </el-form-item>
              <el-form-item label="视频">
                  <GridSelectVideo style="width: 186px;" labelName="videoDesc" labelValue="id"
                  :value="queryForm.videoId" :limit='1' size='small' placeholder='请选择视频' @getValue="getSeachValueVideo" :columns="VIDEO_code" :searchs="VIDEO_search" dataListUrl="/video/video/findList" entityBeanName="videoVideo" queryEntityUrl="/video/video/get">
              </GridSelectVideo>
              </el-form-item>
              <el-form-item label="用户">
                  <GridSelectU style="width: 186px;" labelName="userName" labelValue="id" :value="queryForm.userId"
                    :limit='1' size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
              </el-form-item>
              <!-- <el-form-item label="父评论ID">
                  <el-input  v-model="queryForm.parentId"></el-input>
              </el-form-item> -->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoCommentList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addVideoComment"
        >新建</el-button> -->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editVideoComment(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteVideoComment(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <!-- <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload> -->
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <!-- <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportVideoCommentList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span> -->
        <span
          class="icon-box"
          @click="refreshVideoCommentList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoCommentList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="samll"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="comment"
        label="评论内容"
      >
          <template slot-scope="scope">
            <div v-if="scope.row.comment">{{scope.row.comment}}</div>
            <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column align="center" prop="video.videoPic" label="视频图片">
          <template slot-scope="scope">
            <div v-if='scope.row.video'>
              <el-image @click='updateSrcList(scope.row.video.videoPic)' style="width: 60px; height: 60px"
                :src="scope.row.video.videoPic" :preview-src-list="srcList"> </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
      > 
      <template slot-scope='scope'>
          <div v-if="scope.row.user">
            <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
            <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
            <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
            <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
          </div>
          <div v-else>--</div>
      </template>
    </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父评论"
      >
          <template slot-scope='scope'>
            <div v-if="scope.row.parent">
              {{ scope.row.parent.comment }}
            </div>
            <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkVideoComment(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editVideoComment(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteVideoComment(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoCommentStates[videoCommentState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoComment"
          ref="videoCommentForm"
          :rules="rules"
          label-width="52px"
          :inline="true"
          size="small"
        >
          <el-form-item
            :label="videoCommentState != 'edit'?'评论' : ''"
            prop="comment"
          >
            <el-input
              size="small"
              type="textarea"
              placeholder='请输入描述'
              :rows="16"
              style="min-width:45vw"
              v-model="videoComment.comment"
              :disabled="videoCommentState == 'check'"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="视频"
            prop="videoId"
            v-show="videoCommentState != 'edit'"
          >
            <GridSelectVideo style="width: 177px;" labelName="videoDesc" :disabled="videoCommentState != 'add'" labelValue="id"
                :value="videoComment.videoId" :limit='1' size='small' placeholder='请选择视频' @getValue="getValueVideo" :columns="[
                  {
                    prop: 'videoPic',
                    label: '照片'
                  },
                  {
                    prop: 'videoDesc',
                    label: '视频描述'
                  },
                  {
                    prop: 'createTime',
                    label: '时间'
                  }
                ]" :searchs="[
                  {
                    prop: 'videoDesc',
                    label: '视频描述'
                  },
                ]" dataListUrl="/video/video/findList" entityBeanName="videoVideo" queryEntityUrl="/video/video/get">
              </GridSelectVideo>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
            v-show="videoCommentState != 'edit'"
          >
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="videoCommentState != 'add'" labelValue="id" :value="videoComment.userId"
                :limit='1' size='small' placeholder='请选择用户' @getValue="getValueUser" :columns="[
                  {
                    prop: 'userName',
                    label: '账号'
                  },
                  {
                    prop: 'userMobile',
                    label: '手机号'
                  },
                  {
                    prop: 'userNickname',
                    label: '昵称',
                  },
                  {
                    prop: 'userRealname',
                    label: '姓名'
                  }
                ]" :searchs="[
                  {
                    prop: 'userName',
                    label: '账号'
                  },
                  {
                    prop: 'userMobile',
                    label: '手机号'
                  }
                ]" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="父评论ID"
            prop="parentId"
            v-show="videoCommentState != 'edit'"
          >
            <el-input
              size="small"
              v-model="videoComment.parentId"
              :disabled="videoCommentState != 'edit'"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoCommentState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import GridSelectVideo from '@/components/video'
import { USER, USER_SEARCH, VIDEO, VIDEO_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        GridSelectVideo
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoCommentList();
                    this.getVideoCommentList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoCommentList();
                    this.getVideoCommentList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                VIDEO_code: VIDEO,
                VIDEO_search: VIDEO_SEARCH,
                queryForm:{
                     comment: '', //评论
                     videoId: '', //视频
                     userId: '', //用户
                     parentId: '', //父评论ID
                },
                srcList: [''],//大图预览
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoCommentState: 'add',
                videoCommentStates: {
                    add: '新建评价',
                    check: '查看评价',
                    edit: '修改评价'
                },

                multipleSelection: [],
                videoCommentList: [],
                videoComment: {
                    comment: '', //评论
                    videoId: '', //视频
                    userId: '', //用户
                    parentId: '', //父评论ID
                },
                btnLoading: false,

                rules: {
                    comment: [{ required: true, message: '评论不能为空', trigger: 'blur' }],
                    videoId: [{ required: true, message: '视频不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    parentId: [{ required: true, message: '父评论ID不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            this.getVideoCommentList();
        },
        methods: {
          // 大图预览
            updateSrcList(src) {
              // console.log(this.srcList)
              this.srcList[0] = src
            },
            // 搜索视频
            getSeachValueVideo(value){
              this.queryForm.videoId = value
              console.log(this.queryForm.videoId)
            },
            // 选择视频
            getValueVideo(value){
              this.videoComment.videoId = value
              console.log(this.videoComment.videoId)
            },
            // 搜索用户
            getSeachValueUser(value) {
                this.queryForm.userId = value
            },
            // 选择用户
            getValueUser(value) {
                this.videoComment.userId = value
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetVideoCommentList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoCommentList = [];
            },
            resetDialog() {
                this.videoCommentState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      comment: '', //评论
                      videoId: '', //视频
                      userId: '', //用户
                      parentId: '', //父评论ID
                };
                this.getVideoCommentList();
            },
            closeDialog() {
                this.showDialog = false
                this.videoComment = {
                      comment: '', //评论
                      videoId: '', //视频
                      userId: '', //用户
                      parentId: '', //父评论ID
                };
            },
            submitForm() {
                if (this.videoCommentState == 'add') {
                    this.$refs.videoCommentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/comment/add`,{ ...this.videoComment }).then((res) => {
                                if (res.success || res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoCommentList();
                                    this.resetDialog();
                                    this.getVideoCommentList();
                                }
                            });
                        }
                    });
                } else if (this.videoCommentState == 'edit') {
                    this.$refs.videoCommentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.videoComment.user
                            delete this.videoComment.video
                            delete this.videoComment.parent
                            post(`/video/comment/edit`,{ ...this.videoComment }).then((res) => {
                                if (res.success || res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoCommentList();
                                    this.resetDialog();
                                    this.getVideoCommentList();
                                }
                            });
                        }
                    });
                }
            },
            addVideoComment() {
                this.showDialog = true;
                this.videoCommentState = 'add';
            },
            checkVideoComment(videoCommentId) {
                console.log(videoCommentId);
                this.currentVideoCommentId = videoCommentId;

                this.getVideoCommentById();
                this.showDialog = true;
                this.videoCommentState = 'check';
            },
            editVideoComment(videoCommentId) {
                console.log('videoComment', videoCommentId);
                if (videoCommentId) {
                    this.currentVideoCommentId = videoCommentId;
                    this.getVideoCommentById();
                } else {
                    this.videoComment = { ...this.videoComment, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoCommentState = 'edit';
            },
            deleteVideoComment(videoCommentId) {
                let ids = '';
                if (videoCommentId) {
                    ids = videoCommentId;
                } else {
                    ids = this.multipleSelection.map((videoComment) => videoComment.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/comment/delete`,{ ids }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoCommentList();
                                this.getVideoCommentList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoCommentList() {
                this.resetVideoCommentList();
                this.getVideoCommentList();
            },
            getVideoCommentList(query = {}) {
                this.loading = true;
                get(`/video/comment/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success || res.code == 200) {
                        this.videoCommentList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getVideoCommentById() {
                get(`/video/comment/get`,{ id: this.currentVideoCommentId }).then((res) =>{
                    if(res.success || res.code == 200){
                      this.videoComment = { ...this.videoComment, ...res.videoComment };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoCommentList() {
                //this.btnLoading = true;
                exprotExcel(`/video/comment/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/comment/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/comment/importData`,formData);
              this.refreshVideoCommentList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoCommentList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoCommentList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>